import dayjs from 'dayjs';
import 'dayjs/locale/fr'; 

dayjs.locale('fr');

export const verifierElligibiliteProgrameError = (programme, demandeur) => {
    if (programme != null){
        if(!programme.sexes.includes(demandeur.sexe)){
            return `Sexe ${demandeur.sexe} non élligible.`
        }
    
        if(!programme.categorieDemandeurs.includes(demandeur.categorieDemandeur)){
            return `Demandeur de catégorie ${demandeur.categorieDemandeur} non élligigle.`
        }
    
        const age = dayjs().diff(dayjs(demandeur.dateNais), "year");
        if(demandeur.typeHandicap != null){
            if (age > programme.ageMaxHandicap || age < programme.ageMinHandicap) return `Limite d'âge doit être entre ${programme.ageMinHandicap} - ${programme.ageMaxHandicap} ans pour les personnes avec handicap. Age actuel ${age} ans.`;
        } else {
            if (age > programme.ageMax || age < programme.ageMin) return `Limite d'âge doit être entre ${programme.ageMin} - ${programme.ageMax} ans. Age actuel ${age} ans.`;
        }
    
        if (demandeur.tauxRemplissageProfil < programme.tauxRemplissageProfilMin)
            return `Taux de remplissage de dossier insuffisant. Minimum réquis ${programme.tauxRemplissageProfilMin}%. Actuel ${demandeur.tauxRemplissageProfil}%.`;
    }

    return;
  }